<template>
  <div class="card-wrapper">
    <b-card v-for="promocode in promocodes" :key="promocode.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ promocode.name }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ promocode.code }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i
            v-if="new Date() > new Date(promocode.end)"
            class="glyph-icon simple-icon-clock datalist-icon status--cancel"
          ></i>
          <i v-else class="glyph-icon simple-icon-check datalist-icon status--finish"></i>
          <router-link
            :to="`/admin/promocodes/edit/${promocode.id}`"
            class="glyph-icon simple-icon-pencil datalist-icon ml-3"
          ></router-link>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    promocodes: {
      type: Array,
      required: true
    }
  }
}
</script>
